import {
  getLeoTimestamp,
  LeoTimestamp,
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface SurveySubmissionDataDTO {
  date: string;
  dailySubmissions: number;
  totalSubmissions: number;
}

export class SurveySubmissionData {
  readonly isSurveySubmissionDataSurveySubmissionData: boolean = true;

  readonly date: LeoTimestamp;
  readonly dailySubmissions: number;
  readonly totalSubmissions: number;

  static readonly constraints = {
    "dailySubmissions": {
      "minValue": 0,
    },
    "totalSubmissions": {
      "minValue": 0,
    }
  }

  constructor(
  date: LeoTimestamp, 
  dailySubmissions: number, 
  totalSubmissions: number
  ) {
    this.date = date;
    SurveySubmissionData.validateDailySubmissions(dailySubmissions);
    this.dailySubmissions = dailySubmissions;
    SurveySubmissionData.validateTotalSubmissions(totalSubmissions);
    this.totalSubmissions = totalSubmissions;
  }

  static fromDTO(dto: SurveySubmissionDataDTO): SurveySubmissionData {
    const date = getLeoTimestamp(dto, "date", InvalidSurveySubmissionDataDateError);
    const dailySubmissions = getInt32(dto, "dailySubmissions", InvalidSurveySubmissionDataDailySubmissionsError);
    const totalSubmissions = getInt32(dto, "totalSubmissions", InvalidSurveySubmissionDataTotalSubmissionsError);
    return new SurveySubmissionData(
      date,
      dailySubmissions,
      totalSubmissions
    );
  }

  toDTO(): SurveySubmissionDataDTO {
    const dto: SurveySubmissionDataDTO = {
        date: this.date.toDTO(),
        dailySubmissions: this.dailySubmissions,
        totalSubmissions: this.totalSubmissions
    };
    return dto;
  }
  private static validateDailySubmissions = (dailySubmissions: number): void => {
    if(dailySubmissions < 0) {
      throw new InvalidSurveySubmissionDataDailySubmissionsMinValueError(
        0,
        `Attribute dailySubmissions has value ${dailySubmissions}. Min value is 0.`
      );
    }
  }
  private static validateTotalSubmissions = (totalSubmissions: number): void => {
    if(totalSubmissions < 0) {
      throw new InvalidSurveySubmissionDataTotalSubmissionsMinValueError(
        0,
        `Attribute totalSubmissions has value ${totalSubmissions}. Min value is 0.`
      );
    }
  }
  
}

SurveySubmissionData.prototype.toString = function toString(): string {
  return `SurveySubmissionData(date='${this.date}',dailySubmissions='${this.dailySubmissions}',totalSubmissions='${this.totalSubmissions}')`;
};

export class InvalidSurveySubmissionDataError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySubmissionDataError";
  }
}
export class InvalidSurveySubmissionDataDateError extends InvalidSurveySubmissionDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySubmissionDataDateError";
  }
}

export class InvalidSurveySubmissionDataDailySubmissionsError extends InvalidSurveySubmissionDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySubmissionDataDailySubmissionsError";
  }
}

export class InvalidSurveySubmissionDataDailySubmissionsMinValueError extends InvalidSurveySubmissionDataDailySubmissionsError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySubmissionDataDailySubmissionsMinValueError";
  }
}

export class InvalidSurveySubmissionDataTotalSubmissionsError extends InvalidSurveySubmissionDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySubmissionDataTotalSubmissionsError";
  }
}

export class InvalidSurveySubmissionDataTotalSubmissionsMinValueError extends InvalidSurveySubmissionDataTotalSubmissionsError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySubmissionDataTotalSubmissionsMinValueError";
  }
}
